import React, { useEffect, useState } from "react";
import api from "../../api/api";
import { Autocomplete } from "../../components/Autocomplete";
import { Input } from "../../components/Input";
import moment from "moment";
import { StatisticsChart, statisticsAxis, statisticsNumberAxis, statisticsGrid, statisticsTooltip } from "../../components/StatisticsChart";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Line,
  LineChart,
  AreaChart,
  Area,
  Cell,
} from "recharts";

export const Cedolini = ({ screenSize, f24, dataF24 }) => {
  const [utenti, setUtenti] = useState([]);
  const [utenteSel, setUtenteSel] = useState(null);
  const [dataA, setDataA] = useState(moment(new Date()).format("YYYY-MM"));
  const [dataDa, setDataDa] = useState(
    moment(new Date()).subtract(6, "months").format("YYYY-MM")
  );
  const [parcellazione, setParcellazione] = useState([]);
  const [parcellazioneAttive, setParcellazioneAttive] = useState([]);
  const [aziende, setAziende] = useState([]);
  const [societaTipologia, setSocietaTipologia] = useState({});
  const [aziendaSel, setAziendaSel] = useState(null);

  const [barSel, setBarSel] = useState(null);
  const [meseSel, setMeseSel] = useState(null);

  console.log('utenti', utenti)
  useEffect(() => {}, [screenSize]);

  const loadUtenti = async (da, a) => {
    const response = await api.get("/referenti_aziende_interno/payroll/list", {
      params: {
        includi_cessati: true,
        da: da,
        a: a
      }
    });

    setUtenti(response.data);
  };

  useEffect(() => {
    loadUtenti(dataDa, dataA);
  }, [dataDa, dataA]);

  useEffect(() => {
    if (utenteSel != 0 && utenteSel && dataA && dataDa) {
      loadParcellazione(utenteSel, dataDa, dataA);
      setBarSel(null);
    } else {
      setAziendaSel(null);
      setBarSel(null);
    }
  }, [utenteSel, dataA, dataDa, aziendaSel]);

  const loadParcellazione = async (referente, da, a) => {
    const parc = await api.get(`/parcellazione/statistiche/referente`, {
      params: { referente: referente, da: da, a: a },
    });
    setParcellazione(parc.data.data);
    setParcellazioneAttive(parc.data.data);
    setAziende(parc.data.societa);
    setSocietaTipologia(parc.data.societaTipologia || {});
  };

  const handleBarClick = (el, index) => {
    let meseSelTemp = parcellazione.filter((row) => row.mese === el.mese);
    let arr = [];
    Object.keys(meseSelTemp[0]).map((el) => {
      if (el !== "mese" && el !== "totale_mese" && meseSelTemp[0][el] !== 0) {
        arr.push({ name: el, value: meseSelTemp[0][el] });
      }
    });

    setMeseSel(arr);
    setBarSel(index);
  };

  const handleChangeAzienda = async (e) => {
    setAziendaSel(e.target.value);
  };

  return (
    <div className="el-container h-fit ">
      <div className="grid grid-cols-12 gap-2 h-full items-end">
        <div className="col-span-12 md:col-span-2">
          <Input
            type="month"
            label={"Da"}
            name="da"
            value={dataDa}
            onChange={async (e) => {
              await setDataDa(e.target.value);
              //loadParcellazione(moment(e.target.value).format("YYYY-MM"),moment(dataA).format("YYYY-MM"))
            }}
            max={moment(dataA).format("YYYY-MM")}
          />
        </div>
        <div className="col-span-12 md:col-span-2">
          <Input
            type="month"
            label={"A"}
            name="a"
            onChange={async (e) => {
              await setDataA(e.target.value);
              //loadParcellazione(moment(dataDa).format("YYYY-MM"),moment(e.target.value).format("YYYY-MM"))
            }}
            min={moment(dataDa).format("YYYY-MM")}
            value={dataA}
          />
        </div>
        <div className="col-span-12 md:col-span-3">
          <Autocomplete
            label={"Referente"}
            name="referente"
            onChange={(e) => {
              setUtenteSel(e.target.value);
              setMeseSel(null);
            }}
            value={utenteSel}
            placeholder="Cerca referente..."
            options={utenti}
          />
        </div>
        {utenteSel && utenteSel != 0 ? (
          <div className="col-span-12 md:col-span-3">
            <Autocomplete
              label={"Azienda"}
              name="aziende"
              onChange={handleChangeAzienda}
              value={aziendaSel}
              placeholder="Cerca azienda..."
              options={aziende.map((el, index) => ({
                id: index + 1,
                name: el,
                badge: societaTipologia[el],
              }))}
            />
          </div>
        ) : (
          ""
        )}
        <div className="col-span-12"><StatisticsChart title="Andamento cedolini per referente" subtitle="Clicca una colonna per il dettaglio clienti del mese" count={parcellazioneAttive.length}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={parcellazioneAttive}
              margin={{
                top: 28,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid {...statisticsGrid} />
              <XAxis {...statisticsAxis} dataKey="mese" />
              <YAxis {...statisticsNumberAxis} />
              <Tooltip {...statisticsTooltip} />
              <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 10 }} />
              <Bar
                dataKey={
                  aziendaSel && aziendaSel != 0
                    ? aziende[aziendaSel - 1]
                    : "totale_mese"
                }
                name={
                  aziendaSel && aziendaSel != 0
                    ? aziende[aziendaSel - 1]
                    : "Cedolini normali"
                }
                fill="#2563EB" radius={[10, 10, 0, 0]} maxBarSize={150}
                activeBar={<Rectangle fill="#60A5FA" stroke="#2563EB" radius={[10, 10, 0, 0]} />}
                onClick={handleBarClick}
              >
                {parcellazioneAttive.map((entry, index) => (
                  <Cell
                    cursor="pointer"
                    fill={index === barSel ? "#60A5FA" : "#2563EB"}
                    key={`cell-${index}`}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </StatisticsChart></div>
        {meseSel ? (
          <div className="col-span-12"><StatisticsChart title="Dettaglio clienti del mese" subtitle="Cedolini per cliente nel mese selezionato" count={meseSel.length}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                width={500}
                height={300}
                data={meseSel}
                margin={{
                  top: 28,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid {...statisticsGrid} />
                <XAxis {...statisticsAxis} dataKey="name" tick={false} />
                <YAxis {...statisticsNumberAxis} />
                <Tooltip {...statisticsTooltip} />

                <Bar name="Cedolini" dataKey={"value"} key={"value"} fill="#2563EB" radius={[10, 10, 0, 0]} maxBarSize={150} />
              </BarChart>
            </ResponsiveContainer>
          </StatisticsChart></div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
